export const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/cancellation-refund-policy", label: "Cancellation & Refund Policy" },
  { to: "/complaints-policy", label: "Complaints Policy" },
  { to: "/cookie-policy", label: "Cookie Policy" },
];

export const COMPANY = {
  name: "Marioway Benefits Consultancy Ltd",
  number: "12784422",
  jurisdiction: "Registered in England and Wales",
  location: "Leeds, United Kingdom",
  email: "info@mariowayltd.com",
  phone: "07383513170",
  website: "www.mariowayltd.com",
  updated: "1 June 2026",
};
